"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* tslint:disable */

/* eslint-disable */
var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FollowArtistPopover_artist",
  "selections": [{
    "alias": null,
    "args": null,
    "concreteType": "ArtistRelatedData",
    "kind": "LinkedField",
    "name": "related",
    "plural": false,
    "selections": [{
      "alias": null,
      "args": [{
        "kind": "Literal",
        "name": "excludeFollowedArtists",
        "value": true
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 3
      }],
      "concreteType": "ArtistConnection",
      "kind": "LinkedField",
      "name": "suggestedConnection",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "ArtistEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [{
          "alias": null,
          "args": null,
          "concreteType": "Artist",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [{
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "internalID",
            "storageKey": null
          }, {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FollowArtistPopoverRow_artist"
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": "suggestedConnection(excludeFollowedArtists:true,first:3)"
    }],
    "storageKey": null
  }],
  "type": "Artist"
};
node.hash = '90657ea28fda4ad1f17942932ad1d208';
var _default = node;
exports.default = _default;
//# sourceMappingURL=FollowArtistPopover_artist.graphql.js.map